<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div [hidden]="hideTemplate">
  <mat-form-field class="lf-field lf-template-picker lf-dropdown">
    <ng-template #showDefaultEmptyTemplate>
      <mat-label class="lf-dropdown-label">
        {{ emptyTemplateName | async }}
      </mat-label>
    </ng-template>
    <mat-select
      panelClass="lf-dropdown-overlay" 
      [placeholder]="emptyTemplateName | async"
      name="template-dropdown"
      id="template-dropdown"
      class="lf-dropdown"
      (selectionChange)="onTemplateChangedAsync($event)"
      (openedChange)="onToggleDropdownAsync($event)"
      [(value)]="templateSelected"
      [compareWith]="compareTemplateInfoFunc"
    >
      <mat-option selected *ngIf="isDropdownDefault">{{ emptyTemplateName | async }}</mat-option>
      <mat-option selected *ngIf="isDropdownError" class="dropdown-error-message">{{ AN_ERROR_OCCURED | async }}</mat-option>
      <div *ngIf="isDropdownDefault">
        <mat-option *ngFor="let template of availableTemplates" [value]="template"
          >{{template.displayName}}
        </mat-option>
      </div>
    </mat-select>
  </mat-form-field>
  <ng-container *ngIf="isTemplateLoading; else checkIfHasError">
    <lf-loader-component></lf-loader-component>
  </ng-container>
  <ng-template #checkIfHasError>
    <ng-container *ngIf="isTemplateError; else checkIfDisplay">
      <div class="error-message">{{ templateErrorMessage | async }}</div>
    </ng-container>
    <ng-template #checkIfDisplay>
      <ng-container *ngIf="isTemplateDisplay; else emptyFieldView">
        <div class="responsive-form-container">
          <ng-template lfFieldView></ng-template>
        </div>
      </ng-container>
    <ng-template #emptyFieldView></ng-template>
    </ng-template>
  </ng-template>
</div>
